import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaTimelineSeparator from './VaTimelineSeparator.vue'

export const VaTimelineSeparator = withConfigTransport(_VaTimelineSeparator)
